/**
 * Route segments under `/administration`. Shared by the desktop route table and
 * the backend URL builders, so a renamed route cannot silently leave a link or
 * the index redirect pointing at nothing.
 */
export const adminRoutePaths = {
  users: 'users',
  eConsults: 'e-consults',
  forms: 'forms',
  specialities: 'specialities',
  announcements: 'announcements',
  consents: 'consents',
} as const;
